var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShieldAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "145px",
    viewBox: "0 0 136 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shield-alt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buscaride-website",
    transform: "translate(-652.000000, -3528.000000)",
    fill: "#516173",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 3007.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(596.500000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield-alt",
    transform: "translate(55.491723, 52.978902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5344652,45.2285415 L67.7184912,28.3919477 L67.7184912,115.964408 C45.8574586,102.514194 29.8952205,78.0872332 27.5344652,45.2285415 Z M135.216855,36.3106588 C135.216855,98.8916669 96.9863442,133.780094 72.9105215,143.865987 C69.5875315,145.258281 65.8491696,145.258281 62.5261795,143.865987 C32.4210655,131.254025 0.220127314,92.4449876 0.220127314,36.3106588 C0.220117852,30.830378 3.4970695,25.8876029 8.52776969,23.7798641 L62.5264608,1.15497525 C65.8494508,-0.237319561 69.5878127,-0.237319561 72.9108028,1.15497525 L126.909494,23.7798641 C131.940084,25.8876907 135.216912,30.8304466 135.216855,36.3106588 Z M121.717182,36.3106588 L67.7182099,13.6857699 L13.7198001,36.3106588 C13.7198001,84.1843579 40.2834999,119.842031 67.7179287,131.334909 C94.0434155,120.310366 121.717182,85.464361 121.717182,36.3106588 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldAlt);
export default __webpack_public_path__ + "static/media/icon_shield-alt.3bd5e725e080f9bfb701fb81aa9bbe6d.svg";
export { ForwardRef as ReactComponent };